"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _withDefaults = _interopRequireDefault(require("../utils/with-defaults"));

var _buttonGroupContext = require("./button-group-context");

var _buttonGroup = _interopRequireDefault(require("./button-group.styles"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const defaultProps = {
  borderWeight: 'normal',
  size: 'md',
  color: 'default'
};

const ButtonGroup = groupProps => {
  const {
    disabled,
    size,
    color,
    bordered,
    ghost,
    light,
    flat,
    shadow,
    auto,
    animated,
    rounded,
    ripple,
    borderWeight,
    children,
    ...props
  } = groupProps;
  const initialValue = (0, _react.useMemo)(() => ({
    disabled,
    size,
    color,
    bordered,
    light,
    ghost,
    flat,
    shadow,
    auto,
    borderWeight,
    animated,
    rounded,
    ripple,
    isButtonGroup: true
  }), [disabled, animated, size, ripple, color, bordered, light, ghost, flat, borderWeight]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_buttonGroupContext.ButtonGroupContext.Provider, {
    value: initialValue,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_buttonGroup.default, {
      size: size,
      bordered: bordered || ghost,
      gradient: groupProps.color === 'gradient',
      ...props,
      children: children
    })
  });
};

ButtonGroup.toString = () => '.nextui-button-group';

const MemoButtonGroup = /*#__PURE__*/_react.default.memo(ButtonGroup);

var _default = (0, _withDefaults.default)(MemoButtonGroup, defaultProps);

exports.default = _default;
module.exports = exports.default;